// YouTube Iframe API 초기화시 콜백함수 등록
window.onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
  // 유튜브 스크립트 로드 여부 전역변수
  TMON.oApp.isLoadedYoutubePlayer = true;
  if (TMON.oApp.oBasicImage) {
    TMON.oApp.oBasicImage.onloadYoutubeApi();
  }
  if (TMON.oApp.oContentsVideo) {
    TMON.oApp.oContentsVideo.onloadYoutubeApi();
  }
};

/**
 * @export
 * @class BasicImage
 * 딜 이미지 영역
 */
export default class BasicImage {
  constructor() {
    this.loadLazyImage();
    // 비디오 여부에 따라 영역 초기화
    this.checkComponentStatus();
    this.setEvent(); // 현재는 PC 에서만 사용
  }

  setEvent() {
    $("#_mainDealImagePaginate").on(
      "click mouseover focus",
      "[data-role=rollup]",
      (e) => {
        this.rollupThumbnail(e);
      }
    );
  }

  clearEvent() {
    this.disableImageMode();
    this.disableVideoMode();
    $("#_mainDealImagePaginate").off(
      "click mouseover focus",
      "[data-role=rollup]"
    );
  }

  loadLazyImage() {
    const welLazyImage = $("[data-role=lazyImage]");
    if (!welLazyImage) {
      return;
    }
    for (let i = 0; welLazyImage.length > i; i += 1) {
      const welTargetImage = $(welLazyImage[i]);
      welTargetImage.attr("style", welTargetImage.attr("data-style"));
    }
  }

  rollupThumbnail(e) {
    const nClickedItemIndex = $(e.currentTarget)
      .closest("li")
      .index();
    $("#image-wrapper")
      .find("li")
      .removeClass("active");
    $("#_mainDealImagePaginate")
      .find("li")
      .removeClass("active");
    $("#image-wrapper")
      .find(`li:nth-child(${nClickedItemIndex + 1})`)
      .addClass("active");
    $("#_mainDealImagePaginate")
      .find(`li:nth-child(${nClickedItemIndex + 1})`)
      .addClass("active");
    e.preventDefault();
  }

  /**
   * 비디오 여부에 따라 영역 초기화
   */
  checkComponentStatus() {
    if (
      $("#_mainDealImage #youtube-wrapper").length > 0 &&
      !TMON.oApp.oUtil.isInternetExplorerUnder11()
    ) {
      // Video Mode
      this.disableImageMode();
      this.enableVideoMode();
    } else {
      // Image Mode
      this.disableVideoMode();
      this.enableImageMode();
    }
  }

  /**
   * 비디오일 때 동작 처리
   *  - youtube 플레이어 스크립트 호출
   */
  enableVideoMode = () => {
    this.loadYoutubeScript();
    if (TMON.oApp.oUtil.isInternetExplorerUnder11()) {
      // IE11 미만인 경우 유튜브를 지원하지 않는다는 안내 메시지를 노출
      $("#_mainDealImage #_youtubeDontSupportIE9").show();
    }
  };

  /**
   * youtube 플레이어 스크립트 호출
   */
  loadYoutubeScript = () => {
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  };

  enableImageMode = () => {
    if (
      !this.oSwiper &&
      $("#_mainDealImage").find("li").length > 1 &&
      TMON.oApp.sPlatform !== "PW"
    ) {
      this.initSwiper();
    }
    if (this.oSwiper) {
      this.oSwiper.on("slideChange", this.setPagination);
    }
    $("#image-wrapper").show();
    $("#_mainDealImagePaginate").show();
  };

  /**
   * initSwiper
   * 이미지 스와이퍼 초기화
   */
  initSwiper = () => {
    this.oSwiper = new window.Swiper("#_mainDealImage", {
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
        stopOnLast: false,
      },
      loop: true,
    });
  };

  /**
   * setPagination
   * Swiper의 slide이동 eventListener
   */
  setPagination = () => {
    $("#_mainDealCurrent").html(this.oSwiper.realIndex + 1);
  };

  /**
   * onloadYoutubeApi
   * YoutubeScript 가 onload 되었을 때
   */
  onloadYoutubeApi = () => {
    // 딜 컨텐츠 동영상이 있을 때 로드되는 경우가 있으므로 분기 처리 추가
    if (
      $("#_mainDealImage #youtube-wrapper").length > 0 &&
      !TMON.oApp.oUtil.isInternetExplorerUnder11()
    ) {
      this.sYoutubeId = this.getYoutubeEmbededUrl();
      this.initPlayer();
    }
  };

  getYoutubeEmbededUrl = () => {
    let ID = "";
    let url =
      TMON.oApp.htStorage.htStaticData.htDealContentInfo.contentInfo
        .mainVideoUrl;
    url = url
      .replace(/(>|<)/gi, "")
      .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_/-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }
    return ID;
  };

  initPlayer = () => {
    setTimeout(() => {
      this.onErrorCheck();
    }, 5000);
    this.oPlayer = new window.YT.Player("youtube-player", {
      height: "100%",
      width: "100%",
      videoId: this.sYoutubeId,
      playerVars: {
        showinfo: 0,
        playsinline: 1,
        fs: 0,
        rel: 0,
        controls: TMON.oApp.sPlatform === "PW" ? 1 : 0,
        autoplay: TMON.oApp.sPlatform === "PW" ? 1 : 0,
        enablejsapi: 1,
        origin: location.origin,
      },
      events: {
        onReady: () => {
          this.onPlayerReady();
        },
        onStateChange: (e) => {
          this.onPlayerStateChange(e);
        },
        onError: () => {
          this.onPlayerError();
        },
      },
    });
    $("#_mainDealImage #youtube-wrapper").on(
      "click",
      "[data-role=youtubePlayToggle]",
      () => {
        const nState = this.oPlayer.getPlayerState();
        /**
         * getPlayerState 는 youtube 공식 API 를 사용하고 있습니다.
         * 상태 반환에 대한 응답값은 아래 명세를 참고하세요.
         * https://developers.google.com/youtube/iframe_api_reference?hl=ko
         */
        if (nState === 1) {
          // 1은 재생중에 대한 값입니다.
          this.oPlayer.pauseVideo();
        } else {
          // 그 외의 값은 대부분 정지 중입니다. 재생 명령을 내려도 괜찮습니다.
          this.oPlayer.playVideo();
        }
      }
    );
  };

  onErrorCheck() {
    if (!this.bSuccessYoutube) {
      this.onPlayerError();
    }
  }

  onPlayerReady = () => {
    this.bSuccessYoutube = true;
    if (TMON.oApp.sPlatform === "PW") {
      this.oPlayer.mute();
    }
    $("#playerLoader").fadeOut("slow");
  };

  onPlayerStateChange = (e) => {
    if (e.data === 1) {
      if (TMON.htStaticData.isAvLiveVideoModule) {
        // 티몬플레이 방송이 있는 딜은 메인 딜 비디오 자동 재생시 stop 하도록 작업
        this.oPlayer.stopVideo();
      }

      // android 일부기종은 버튼이 있으면 재생이 안되고, ios(app, MW 모두)는 버튼이 없을 때 비디오영역 토글이 안됨
      // android 도 사용자 재생만 이뤄지면 이후 playVideo메서드가 동작하므로, 재생 후 버튼을 되살림 SDLUI-610, SDLUI-612
      $("#_youtube_button").show();
      // 동영상 재생되면 좌측상단 sticker 없애버림
      $("[ data-role=stickerOnBasicImage]").remove();
      $("[ data-role=upperStickerOnBasicImage]").remove();
      if (TMON.view_mode === "app") {
        TMON.app.callApp(
          "webview",
          "setWebProperties",
          '{"isYoutubePlay":true}'
        );
      }
    } else if (e.data === 0 || e.data === 2) {
      if (TMON.view_mode === "app") {
        TMON.app.callApp(
          "webview",
          "setWebProperties",
          '{"isYoutubePlay":false}'
        );
      }
    }
    // 반복재생
    if (e.data === 0) {
      this.oPlayer.playVideo();
    }
  };

  onPlayerError = () => {
    this.disableVideoMode();
    this.enableImageMode();
  };

  disableVideoMode = () => {
    if (this.oPlayer) {
      this.oPlayer.destroy();
      delete this.oPlayer;
    }
    $("#_mainDealImage #youtube-wrapper").hide();
  };

  disableImageMode = () => {
    if (this.oSwiper) {
      this.oSwiper.destroy();
    }
    $("#_mainDealImagePaginate").hide();
    $("#image-wrapper").hide();
  };
}
